export function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isAppDevice() {
    return /La\sRedoute/gim.test(navigator.userAgent);
}
